import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const PIECES = [
  { points: "24,3 42,14.5 24,24", fill: "#D2A74B", from: { x: -20, y: -26 } },
  { points: "24,3 24,24 6,14.5", fill: "#C05A35", from: { x: 18, y: -30 } },
  { points: "6,14.5 24,24 24,44", fill: "#610C27", from: { x: -28, y: 12 } },
  { points: "6,14.5 24,44 6,33.5", fill: "#42081B", from: { x: -16, y: 26 } },
  { points: "24,24 42,14.5 42,33.5", fill: "#00474B", from: { x: 26, y: 10 } },
  { points: "24,24 42,33.5 24,44", fill: "#023338", from: { x: 16, y: 28 } },
];

const MosaicCube = ({ className = "", mode = "view", delay = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const show = mode === "load" || inView;

  return (
    <svg ref={ref} viewBox="-30 -30 108 108" className={className} aria-hidden="true">
      {PIECES.map((p, i) => (
        <motion.polygon
          key={i}
          points={p.points}
          fill={p.fill}
          initial={{ x: p.from.x, y: p.from.y, opacity: 0 }}
          animate={show ? { x: 0, y: 0, opacity: 1 } : { x: p.from.x, y: p.from.y, opacity: 0 }}
          transition={{ duration: 1.1, delay: delay + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
        />
      ))}
    </svg>
  );
};

export default MosaicCube;
